import React, { useState } from 'react'
import * as Styled from '../NewsFeedV1Settings.styled'

interface NewsSourceEditorProps {
  newsSources: string[]
  onSave: (newsSources: string[]) => void
  isSaving?: boolean
}

const NewsSourceEditor: React.FC<NewsSourceEditorProps> = ({ 
  newsSources, 
  onSave, 
  isSaving = false 
}) => {
  const [localNewsSources, setLocalNewsSources] = useState<string[]>([...newsSources])
  const [newNewsSource, setNewNewsSource] = useState('')

  const addNewsSource = (newsSource: string) => {
    if (!newsSource.trim()) return

    const trimmedSource = newsSource.trim()
    if (!localNewsSources.includes(trimmedSource)) {
      setLocalNewsSources([...localNewsSources, trimmedSource])
      setNewNewsSource('')
    }
  }

  const removeNewsSource = (newsSource: string) => {
    setLocalNewsSources(localNewsSources.filter(source => source !== newsSource))
  }

  const handleSave = () => {
    onSave(localNewsSources)
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      addNewsSource(newNewsSource)
    }
  }

  return (
    <div>
      <Styled.NewsSourceSection>
        <Styled.NewsSourceSectionTitle>Haber Kaynakları</Styled.NewsSourceSectionTitle>
        <Styled.NewsSourceList>
          {localNewsSources.map((source, index) => (
            <Styled.NewsSourceTag key={index}>
              <span>{source}</span>
              <Styled.RemoveButton
                onClick={() => removeNewsSource(source)}
                title="Kaldır"
                disabled={isSaving}
              >
                ×
              </Styled.RemoveButton>
            </Styled.NewsSourceTag>
          ))}
        </Styled.NewsSourceList>
        <Styled.AddNewsSourceForm>
          <Styled.NewsSourceInput
            type="text"
            value={newNewsSource}
            onChange={(e) => setNewNewsSource(e.target.value)}
            placeholder="Yeni haber kaynağı ekle"
            onKeyPress={handleKeyPress}
            disabled={isSaving}
          />
          <Styled.AddButton
            onClick={() => addNewsSource(newNewsSource)}
            disabled={!newNewsSource.trim() || isSaving}
          >
            Ekle
          </Styled.AddButton>
        </Styled.AddNewsSourceForm>
      </Styled.NewsSourceSection>
      
      <Styled.ActionsContainer>
        <Styled.SaveButton 
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
        </Styled.SaveButton>
      </Styled.ActionsContainer>
    </div>
  )
}

export default NewsSourceEditor
